import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

const dummyData = [
    { id: 1, withdrawalDate: '2024-05-01', type: 'Bank', amount: 1000, merchantId: 'M001', merchantName: 'John Doe', withdrawalMethod: 'Bank Transfer', status: 'Approved' },
    { id: 2, withdrawalDate: '2024-05-10', type: 'Wallet', amount: 500, merchantId: 'M002', merchantName: 'Jane Smith', withdrawalMethod: 'Wallet', status: 'Pending' },
    { id: 3, withdrawalDate: '2024-05-15', type: 'Bank', amount: 2000, merchantId: 'M003', merchantName: 'Alice Brown', withdrawalMethod: 'Bank Transfer', status: 'Approved' },
    { id: 4, withdrawalDate: '2024-05-20', type: 'Wallet', amount: 750, merchantId: 'M004', merchantName: 'Bob White', withdrawalMethod: 'Wallet', status: 'Pending' }
];

const MerchantWithdrawal = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [data, setData] = useState(dummyData);
    const dt = React.useRef(null);

    // const filterData = () => {
    //     let filtered = dummyData;
    //     if (startDate) {
    //         filtered = filtered.filter((row) => new Date(row.withdrawalDate) >= new Date(startDate));
    //     }
    //     if (endDate) {
    //         filtered = filtered.filter((row) => new Date(row.withdrawalDate) <= new Date(endDate));
    //     }
    //     setData(filtered);
    // };

    const exportCSV = () => {
        if (dt.current) {
            dt.current.exportCSV();
        }
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    <Button
                        tooltip="Edit"
                        icon="pi pi-pencil"
                        tooltipOptions={{ position: 'top' }}
                        disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
                        // onClick={() => EditUiElement(rowData)}
                        className="p-button-rounded p-button-primary mr-2"
                    />
                    <Button
                        tooltip="View Details"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        // onClick={() => ViewUiElement(rowData)}
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />
                </div>
            </>
        );
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Merchant Withdrawal Request</h3>
                <div className="flex gap-2">
                    <Calendar value={startDate} onChange={(e) => setStartDate(e.value)} placeholder="Start Date" dateFormat="yy-mm-dd" showIcon />
                    <Calendar value={endDate} onChange={(e) => setEndDate(e.value)} placeholder="End Date" dateFormat="yy-mm-dd" showIcon />
                    {/* <Button label="Filter" icon="pi pi-filter" onClick={filterData} className="p-button-sm" /> */}
                    {/* <Button label="Add Merchant" icon="pi pi-plus" className="p-button-success p-button-sm" /> */}
                </div>
            </div>
            <DataTable
                value={data}
                paginator
                rows={5}
                className="p-datatable-sm"
                footer={
                    <div className="flex justify-content-end">
                        <Button label="Export CSV" icon="pi pi-download" className="p-button-info p-button-sm" onClick={exportCSV} />
                    </div>
                }
            >
                <Column field="id" header="Withdrawal Id" body={(rowData, options) => options.rowIndex + 1} style={{ width: '60px' }} />
                <Column field="withdrawalDate" header="Withdrawal Date" />
                <Column field="type" header="Type" />
                <Column field="amount" header="Amount" />
                <Column field="merchantId" header="Merchant Id" />
                <Column field="merchantName" header="Merchant Name" />
                <Column field="withdrawalMethod" header="Withdrawal Method" />
                <Column field="status" header="Status" body={(rowData) => <span className={`badge ${rowData.status === 'Approved' ? 'bg-success' : 'bg-warning'}`}>{rowData.status}</span>} />
                <Column header="Actions" body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>
        </div>
    );
};

export default MerchantWithdrawal;
